import Papa from 'papaparse'
Papa.SCRIPT_PATH = '/assets/js/papaparse.js'

export default {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$papa', { value: Papa })
  }
}

export const papaparse = Papa
